/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: external-metadata-template
 *
 * Created by rwilliams on 10/5/17.
 */

function ExternalMetadataController(
    this: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    ExternalMetadataService: JS5Object,
    NotificationService: JS5Object,
) {
	this.activeTabs = {
		setup: false,
        queue: false,
		logging: false
	};

	this.onTabSelect = function (tab: string): void {
		$route.updateParams({view: tab});
	};

	this.onTabDeselect = function (tab: string, event: any): void {
		if (ExternalMetadataService.editorForm && ExternalMetadataService.editorForm.$dirty) {
			event.preventDefault();
			NotificationService.createWarningNotification('Please save or revert your changes before navigating away from this page.');
		}
	};

	this.$onInit = (): void => {
		this.currentTab = $routeParams.view;
		this.activeTabs[$routeParams.view] = true;
	};
}

angular.module('prism-ui.externalMetadata').component('externalMetadata', {
	controller: ExternalMetadataController,
	templateUrl: 'system/externalMetadata/external-metadata-template.html'
});
